"use client";

import { c as _c } from "react/compiler-runtime";
import { Button, Textarea } from "@/components/ui";
import { Dialog, DialogBody, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { useAIChatContext } from "./contexts";

/**
 * Feedback dialog for negative AI chat feedback.
 * Reads all state from AIChatContext's `feedback` field.
 * Must be rendered inside an AIChat.Provider that supplies `feedback`.
 */
export function AIChatFeedbackDialog() {
  const $ = _c(23);
  const {
    feedback
  } = useAIChatContext();
  if (!feedback) {
    throw new Error("AIChat.FeedbackDialog requires `feedback` in AIChatContext. Pass feedback to AIChat.Provider, or don't compose FeedbackDialog.");
  }
  const {
    state: fs,
    actions: fa
  } = feedback;
  let t0;
  if ($[0] !== fa) {
    t0 = open => !open && fa.closeFeedbackDialog();
    $[0] = fa;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <DialogHeader><DialogTitle>Provide Feedback</DialogTitle></DialogHeader>;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <label htmlFor="feedback-textarea" className="text-body-strong text-foreground-secondary">What could be improved?</label>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== fa) {
    t3 = e => fa.setFeedbackText(e.target.value);
    $[4] = fa;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== fs.feedbackText || $[7] !== t3) {
    t4 = <DialogBody><div className="space-y-2">{t2}<Textarea id="feedback-textarea" value={fs.feedbackText} onChange={t3} placeholder="Please share your feedback..." rows={4} className="resize-none" /></div></DialogBody>;
    $[6] = fs.feedbackText;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== fa.closeFeedbackDialog) {
    t5 = <Button variant="secondary" onClick={fa.closeFeedbackDialog}>Cancel</Button>;
    $[9] = fa.closeFeedbackDialog;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== fa.submitFeedback) {
    t6 = <Button onClick={fa.submitFeedback}>Submit</Button>;
    $[11] = fa.submitFeedback;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t5 || $[14] !== t6) {
    t7 = <DialogFooter>{t5}{t6}</DialogFooter>;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t4 || $[17] !== t7) {
    t8 = <DialogContent className="max-w-lg">{t1}{t4}{t7}</DialogContent>;
    $[16] = t4;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== fs.isOpen || $[20] !== t0 || $[21] !== t8) {
    t9 = <Dialog open={fs.isOpen} onOpenChange={t0}>{t8}</Dialog>;
    $[19] = fs.isOpen;
    $[20] = t0;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  return t9;
}